import { createDrawingCanvas, getDrawingContext2d } from './drawing-canvas'

let preferCanvas = false

export function resetVideoBitmapFallback(): void {
  preferCanvas = false
}

export async function captureVideoBitmap(video: HTMLVideoElement): Promise<ImageBitmap> {
  if (!preferCanvas && typeof createImageBitmap === 'function') {
    try { return await createImageBitmap(video) }
    catch { preferCanvas = true }
  }
  const width = video.videoWidth
  const height = video.videoHeight
  if (!width || !height) throw new Error('捕获画面尚未就绪')
  const canvas = createDrawingCanvas(width, height)
  getDrawingContext2d(canvas).drawImage(video, 0, 0, width, height)
  if (typeof createImageBitmap === 'function') return createImageBitmap(canvas)
  throw new Error('2D canvas is unavailable')
}
